import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import vxeTable from "./src/vxe-table.vue";
import dragRowTable from "./src/drag-row-table.vue";
import mergeColumnTable from "./src/merge-column-table.vue";
import mergeRowTable from "./src/merge-row-table.vue";
import miniList from "./src/mini-list.vue";
export const xVxeTable = withInstall(vxeTable, {
  dragRowTable,
  mergeColumnTable,
  mergeRowTable,
  miniList,
});
export default xVxeTable;
export const xDragRowTable = withNoopInstall(dragRowTable);
export const xMergeColumnTable = withNoopInstall(mergeColumnTable);
export const xMergeRowTable = withNoopInstall(mergeRowTable);
export const xMiniList = withNoopInstall(miniList);
export * from "./src/table";
export * from "./src/mini-list";
